import { ShareAccessLevel } from '../ShareAccess.types';

type ProjectType = 'design' | 'template';

export const getAccessDataMap = (
  projectType?: ProjectType
): Record<
  ShareAccessLevel,
  {
    id: ShareAccessLevel;
    labelKey: string;
    subtitleKey: string;
    icon: string;
    confirmDescriptionKey: string;
    typeKey: string;
  }
> => ({
  [ShareAccessLevel.Public]: {
    id: ShareAccessLevel.Public,
    labelKey: 'shared.share_viewer_access.public.title',
    subtitleKey: 'shared.share_viewer_access.public.subtitle',
    icon: 'globe',
    confirmDescriptionKey: 'shared.share_viewer_access.to_public_confirm_description',
    typeKey: 'shared.share_viewer_access.public_type',
  },
  [ShareAccessLevel.TeamShared]: {
    id: ShareAccessLevel.TeamShared,
    labelKey: 'shared.share_viewer_access.team.title',
    subtitleKey: 'shared.share_viewer_access.team.subtitle',
    icon: 'users',
    confirmDescriptionKey: 'shared.share_viewer_access.to_team_confirm_description',
    typeKey: 'shared.share_viewer_access.team_type',
  },
  [ShareAccessLevel.Private]: {
    id: ShareAccessLevel.Private,
    labelKey: 'shared.share_viewer_access.private.title',
    subtitleKey:
      projectType === 'template'
        ? 'shared.share_viewer_access.private_template.subtitle'
        : 'shared.share_viewer_access.private.subtitle',
    icon: 'lock---20',
    confirmDescriptionKey: 'shared.share_viewer_access.to_private_confirm_description',
    typeKey: 'shared.share_viewer_access.private_type',
  },
});
